import Link from 'next/link';
import { dappStore } from '@components/store';
import Button from '../Button';

export default function CloseConfirmationModal() {
  const close = () => {
    dappStore.setState({ isCloseConfirmationModal: false });
  };
  return (
    <>
      <p>Your position has been closed. Proceeds from this position are now in your wallet.</p>
      <p>
        <Link href="/open-position">
          <Button onClick={close}>Open Another Position</Button>
        </Link>
      </p>
    </>
  );
}
